/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Placeholder_NameInputs */

const et_contact_placeholder_name = /** @type {(inputs: Contact_Placeholder_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mari Maasik`)
};

const en_contact_placeholder_name = /** @type {(inputs: Contact_Placeholder_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`John Smith`)
};

/**
* | output |
* | --- |
* | "John Smith" |
*
* @param {Contact_Placeholder_NameInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_placeholder_name = /** @type {((inputs?: Contact_Placeholder_NameInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Placeholder_NameInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_contact_placeholder_name(inputs)
	return en_contact_placeholder_name(inputs)
});